import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { isAxiosError } from "axios"

import { getOrgPropertiesFn, updateOrgPropertiesFn } from "@/api/ordersApi"
import { OrgProperties } from "@/shared/types"
import { showToast } from "@/shared/utils"

export const orderOrgPropertyKeys = [OrgProperties.FEATURE_FLAG_UI_ORDER_REPROCESS_ENABLED]

export const useOrderOrgProperties = (orgId: string) =>
  useQuery(
    ["orderOrgProperties", orgId],
    () => getOrgPropertiesFn(orgId, orderOrgPropertyKeys),
    {
      enabled: !!orgId,
      staleTime: 30 * 1000,
      onError: (error) => {
        if (isAxiosError(error)) {
          showToast({ type: "error", text: error.response?.data.errorMessage || error.message })
        }
      },
    },
  )

export const useUpdateOrderOrgProperties = (orgId: string) => {
  const queryClient = useQueryClient()

  return useMutation(
    (properties: { propertyKey: OrgProperties; value: string }[]) =>
      updateOrgPropertiesFn(orgId, properties),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["orderOrgProperties", orgId])
        queryClient.invalidateQueries(["allOrgProperties"])
        showToast({ type: "success", text: "Order settings saved." })
      },
      onError: (error) => {
        if (isAxiosError(error)) {
          showToast({ type: "error", text: error.response?.data.errorMessage || error.message })
        }
      },
    },
  )
}
